export default __webpack_public_path__ + "static/media/404-notfound.dcb2ff4c.jpg";